import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc.js'
import timezone from 'dayjs/plugin/timezone.js'
dayjs.extend(utc);
dayjs.extend(timezone);
import getItemStyles from '../../../utils/item-styles.js';
import timelineDisplayOrder from './timelineDisplayOrder.js';
import ignoreDummyComments from '../../../../../utils/ignoreDummyComments.js';

/**
 * Returns a formatted day off item for the one to two day posted schedule.
 * @param {*} resource
 * @param {*} dayType
 */
const generateOffTime = (resource, dayType) => {
  dayjs.tz.setDefault('UTC');
  const { rId } = resource;
  if(dayType === undefined){
    return 'Insert a properDayOff format'
  }
  const { dorId, abbreviation, startTime, endTime, dayTypeComment, myDayTypeComment, isApproved } = dayType.dayOff;
  let hasComment = false;
  if ( ignoreDummyComments(dayTypeComment || myDayTypeComment) && dayType !== undefined) {
    hasComment = true;
  }
  const offtimeStyle = getItemStyles('offtime');
  const momentStartTime = dayjs(dayjs.unix(startTime).utc().format("YYYY-MM-DD HH:mm:ss"));
  const offsetTime =0;
  const offsetStartTime = dayjs(momentStartTime).add(offsetTime, 'minute');
  const offsetEndTime = dayjs(dayjs.unix(endTime).utc().format("YYYY-MM-DD HH:mm:ss"));

  const offTimeBase = {
    itemType: 'off-time',
    group: rId,
    dorId,
    abbreviation,
    start_time: offsetStartTime,
    end_time: offsetEndTime,
    dayTypeComment,
    myDayTypeComment,
    backgroundColor: dayType.dayOff.isApproved ? 'gray' : offtimeStyle.backgroundColor,
    borderStyle: offtimeStyle.borderStyle,
    borderColor: hasComment ? 'red' : offtimeStyle.borderColor,
    timelineDisplayOrder: timelineDisplayOrder.dayOff,
    dayRequestId: dayType.dayRequestId && dayType.dayRequestId !== '0' ? dayType.dayRequestId : null,
    isApproved
  };
  
  const offTime = {
    ...offTimeBase,
    id: dayType.rdtId === undefined ? dayType.id : dayType.rdtId,
    title: dayType.dayTypeName === undefined ? dayType.dayOff.title : dayType.dayTypeName,
    dayType: dayType.dayTypeName === undefined ? dayType : undefined
  };
  return offTime;
}

export default generateOffTime;
